module.exports = require("react-onclickoutside");